import CollectionsItem from './CollectionsItem';

export default CollectionsItem;



// WEBPACK FOOTER //
// ./src/components/CollectionsItem/index.js